export default __webpack_public_path__ + "static/media/baths.04991f2c.jpg";